import { render } from "./stock-charts.vue?vue&type=template&id=1788e138"
import script from "./stock-charts.vue?vue&type=script&lang=ts"
export * from "./stock-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script